// A one-use, memory-only editor draft, bound to the current account and workspace. Selected
// document text never rides a URL or survives an account switch in persistent browser storage.
let pending: { userId: string; workspaceId: string; text: string } | null =
  null;
export function putAssistantDraft(
  userId: string,
  workspaceId: string,
  text: string
) {
  pending = { userId, workspaceId, text };
}
export function takeAssistantDraft(
  userId: string,
  workspaceId: string
): string {
  const draft = pending;
  pending = null;
  return draft?.userId === userId && draft.workspaceId === workspaceId
    ? draft.text
    : '';
}
